import { Map } from 'immutable';
import {
    GET_REPLANDETAILS,
    SAVE_PERSONAL_DETAILS,
    SAVE_HOME_DETAILS,
    SAVE_WORK_DETAILS,
    SAVE_ALTERNATE_DETAILS,
    SAVE_REIMBURSEMENT_DETAILS,
    UPDATE_REIMBURSEMENT_DETAILS,
    SAVE_HOUSING_DETAILS,
    SAVE_INVENTORY_NAME,
    SET_HOME_LOADING,
    SET_WORK_LOADING,
    SET_HOUSING_LOADING
} from '../../actions/relocation/relocationPlanServiceDetails';
import {
  STREET_ADDRESS,
  SUBURB,
  STATE,
  COUNTRY,
  POST_CODE,
  PHONE,
  MOBILE,
  STREET_ADDRESS2,
  SUBURB2,
  STATE2,
  COUNTRY2,
  POST_CODE2,
  EMAIL,
  POSTITION,
  STATE3,
  POST_CODE3,
  COUNTRY3,
  STREET_ADDRESS3,
  SUBURB3,
  UNIT_LOCATION,
  UNIT,
  PHONE3,
  EMAIL3,
  NAME,
  CONTACT_NUMBER,
  EMAIL4,
  OTHER,
  RELATIONSHIP,
  STREET_ADDRESS_LONGITUDE,
  STREET_ADDRESS_LATITUDE,
  POSTAL_ADDRESS_LONGITUDE,
  POSTAL_ADDRESS_LATITUDE
} from "../../../constants/plaintext/relocationRequest";


const initialState = Map({
    rePlanDetails:[],
    personalDetails:{
      isVerify:false
    },
    homeDetails:{
    [STREET_ADDRESS]: "",
    [SUBURB]: "",
    [STATE]: "",
    [POST_CODE]: "",
    [COUNTRY]: "",
    [PHONE]:"",
    [MOBILE]:"",
    [STREET_ADDRESS2]: "",
    [SUBURB2]: "",
    [STATE2]: "",
    [POST_CODE2]: "",
    [COUNTRY2]: "",
    [EMAIL]: "",
    isVerify:false,
    [STREET_ADDRESS_LONGITUDE]: "",
    [STREET_ADDRESS_LATITUDE]: "",
    [POSTAL_ADDRESS_LONGITUDE]: "",
    [POSTAL_ADDRESS_LATITUDE]: ""
    },
    workDetails:{
    [POSTITION]: "",
    [STREET_ADDRESS3]: "",
    [SUBURB3]: "",
    [STATE3]: "",
    [POST_CODE3]: "",
    [COUNTRY3]: "",
    [UNIT_LOCATION]:"",
    [UNIT]: "",
    [PHONE3]: "",
    [EMAIL3]: "",
    [STREET_ADDRESS_LONGITUDE]: "",
    [STREET_ADDRESS_LATITUDE]: "",
    isVerify:false
    },
    alternateDetails:{
    [NAME]:"",
    [CONTACT_NUMBER]:"",
    [EMAIL4]:"",
    [RELATIONSHIP]: "",
    [OTHER]: ""
    },
    reimbursementDetails:{},
    housingConsiderations:{},
    inventoryName:[],
    homeLoading: false,
    workLoading: false,
    housingLoading: false
});

const actionsMap = {
  [GET_REPLANDETAILS]: (state, action) => {
    return state.set('rePlanDetails', action.rePlanDetails);
  },
  [SAVE_PERSONAL_DETAILS]: (state, action) => {
    return state.set('personalDetails', action.data);
  },
  [SAVE_HOME_DETAILS]: (state, action) => {
    return state.set('homeDetails', action.data);
  },
  [SAVE_WORK_DETAILS]: (state, action) => {
    return state.set('workDetails', action.data);
  },
  [SAVE_ALTERNATE_DETAILS]: (state, action) => {
    return state.set('alternateDetails', action.data);
  },
  [SAVE_REIMBURSEMENT_DETAILS]: (state, action) => {
    return state.set('reimbursementDetails', action.data);
  },
  [UPDATE_REIMBURSEMENT_DETAILS]: (state, action) => {
    return state.set('reimbursementDetails', action.data);
  },
  [SAVE_HOUSING_DETAILS] : (state, action) => {
    return state.set('housingConsiderations', action.data);
  },
  [SAVE_INVENTORY_NAME] : (state, action) => {
    return state.set('inventoryName', action.data);
  },
  [SET_HOME_LOADING]: (state, action) => {
    return state.set('homeLoading', action.homeLoading);
  },
  [SET_WORK_LOADING]: (state, action) => {
    return state.set('workLoading', action.workLoading);
  },
  [SET_HOUSING_LOADING]: (state, action) => {
    return state.set('housingLoading', action.housingLoading);
  },
};

export default function facilities(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}